<template>
  <v-container id="campuses" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <base-material-card
          :title="$i18n.t('Journey Gap')"
          icon="mdi-account-tie"
          class="px-3 py-3 small-icon"
          color="primary"
        >
          <v-container>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-container class="py-0">
                <v-row>
                  <v-col cols="12" class="text-right">
                    <v-btn small class="float-right" color="blue" @click="add()">
                      <v-icon>mdi-plus</v-icon>
                      {{ $i18n.t("Add") }}
                    </v-btn>
                  </v-col>
                </v-row>
                <v-card>
                  <v-simple-table dense style="padding: 10px">
                    <thead>
                      <tr>
                        <th class="primary--text">{{ $i18n.t("Country") }}</th>
                        <th class="primary--text">{{ $i18n.t("Currency") }}</th>
                        <th class="text-right primary--text">Default</th>
                        <th class="text-right primary--text">Actions</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="data in currencyMaps" :key="data.country">
                        <td>
                          <z-country-select class="purple-input" v-model="data.country"></z-country-select>
                        </td>
                        <td>
                          <z-country-select class="purple-input" v-model="data.country"></z-country-select>
                        </td>
                        <td>
                          <v-checkbox v-model="data.isDefault" :label="$i18n.t('Default')"></v-checkbox>
                        </td>
                        <td>
                          <v-btn @click="remove()">
                            <v-icon>mdi-trash-can-outline</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                      <v-spacer></v-spacer>
                    </tbody>
                  </v-simple-table>
                </v-card>
              </v-container>
            </v-col>
          </v-container>
          <v-col cols="12" class="text-right">
            <v-btn color="success" class="mr-0" @click="save()" :loading="loading">
              <h3>{{ $i18n.t("Save") }}</h3>
            </v-btn>
          </v-col>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Holidays extends Vue {
  corporateConfig = {
    currencyMaps: [],
  };
  url = "/api/corp/config/get";
  currencyMaps = [];

  get loading() {
    return common.loading;
  }

  add() {
    if (this.currencyMaps == null) {
      this.currencyMaps = [];
    }

    this.currencyMaps.push({
      isDefault: "",
    });
  }

  async mounted() {
    try {
      this.corporateConfig = await doGet(this.url);
      this.currencyMaps = this.corporateConfig.currencyMaps;
    } catch (e) {
      common.setError(e.message);
    }
  }
  remove(_index) {
    this.currencyMaps.splice(_index, 1);
  }

  async save() {
    try {
      common.setLoading(true);
      this.corporateConfig.currencyMaps = this.currencyMaps;
      // console.log(this.corporateConfig);
      await doPost("/api/corp/config/countryMap/save", this.corporateConfig);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
#bookingCheckbox {
  margin-left: 20px;
  margin-right: 20px;
  justify-content: space-between;
}
</style>
